// extracted by mini-css-extract-plugin
module.exports = {"vg9xh0y":"vg9xh0y","hnhigwh":"hnhigwh","v15hxnri":"v15hxnri","a2k1s4l":"a2k1s4l"};